import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Title } from "../Components/styled/Typo";

const Parent = styled.div`
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  overflow: none;
`;

const Flip = styled.div`
  background: url("space2.jpg");
  /* background-position: center; */
  background-size: cover;
  /* object-fit: contain; */
  width: 35%;
  height: 100%;
`;

const SummaryContainer = styled.div`
  /* background: #2b2d42;
color: white; */
  color: #22223b;
  width: 64%;
  height: 100%;
  overflow-y: auto;
  padding-left: 90px;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
`;

const LinkComponent = styled(Link)`
  text-decoration: none;
  color: #121c29;
  font-size: 1.2rem;
  letter-spacing: 0.2rem;
  color: #121c29;
  &:hover {
    color: #e63946;
  }
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 25px;
`;

export default function SummaryTest() {
  return (
    <Parent>
      <Flip></Flip>

      <SummaryContainer>
        <Box>
          <Title style={{ color: "#141414" }}>SUMMARY</Title>

          <LinkComponent to={"/"}>Home</LinkComponent>

          <LinkComponent to={"/univers"}>
            {" "}
            Human's Desire to Explore the Universe
          </LinkComponent>

          <LinkComponent to={"/human"}>
            {" "}
            Human Achievements in Space Exploration{" "}
          </LinkComponent>

          <LinkComponent to={"/solar"}> The Sun </LinkComponent>

          <LinkComponent to={"/parker-description"}>
            {" "}
            The Parker Solar Probe{" "}
          </LinkComponent>
        </Box>
        <Box>
          <Title style={{ color: "#141414" }}>3D Models</Title>
          <LinkComponent to={"/solar-system"}> 3D Solar System </LinkComponent>
          <LinkComponent to={"/parker-probe"}>
            3D Parker Solar Probe
          </LinkComponent>
        </Box>
      </SummaryContainer>
    </Parent>
  );
}
